export interface BaseResult {
  succeeded: boolean
  message: string
}

export interface BaseResponse {
  succeeded: boolean
  message: string
}

export interface BaseApiResult {
  succeeded: true
  message: string
}

export interface BaseApiError {
  succeeded: false
  message: string
}

export const apiErrorStatuses = {
  OK: 100,
  INVALID_PARAMETERS: 300,
  EMAIL_USED: 301,
  EMAIL_NOT_REGISTERED: 302,
  INVALID_PASSWORD: 303,
  SAME_PASSWORD: 304,
  TEMPORARY_REGISTRATION: 305,
  INVALID_X_API_TOKEN: 400,
  INVALID_EMAIL_OR_PASSWORD: 401,
  LOGIN_EXPIRED: 402,
  INVALID_CSRF_TOKEN: 403,
  INVALID_REGISTRATION_TOKEN: 404,
  TOKEN_USED: 405,
  INVALID_AUTH_TOKEN: 406,
  TOKEN_EXPIRED: 407,
  ACCOUNT_LOCKED: 411,
  // なりかわりが必要（運営アカウントが他社リソースを開いた）
  SUBSTITUTE_REQUIRED: 448,
  INTERNAL_SERVER_ERROR: 500,
}
